import React from "react"


import {
  Breadcrumb,
  Col,
  Container,
  Row
} from "react-bootstrap"

import Image from "../components/CustomImage"
import data from "../data/contact.json"
// import Icon from "../components/Icon"
import BreadcrumbItem from "../components/BreadcrumbItem"
import ContactForm from "../components/Controls/ContactForm"
import Map from "../components/Map"
import geoJSON from '../data/contact-geojson.json'


export async function getStaticProps() {
  return {
    props: {
      nav: {
        light: true,
        classes: "shadow",
        color: "white",
      },
      title: "Get in touch",
      meta: data.meta,
      canonical: `${process.env.BASE_URL}/contact`
    },
  }
}

const Contact = () => {
  const [hoverCard, setHoverCard] = React.useState(null)

  const onCardEnter = (id) => {
    setHoverCard(id)
  }
  const onCardLeave = () => {
    setHoverCard(null)
  }

  return (
    <React.Fragment>
      <section className="hero py-6 py-lg-7 text-white dark-overlay">
        {data.img && (
          <Image
            src={`/content/img/photo/${data.img}`}
            alt={data.title}
            className="bg-image"
            loading="eager"
            fill
            priority
          />
        )}
        <Container className="overlay-content">
          <Breadcrumb listProps={{ className: "text-white justify-content-center no-border mb-0" }}>
            <BreadcrumbItem href="/">Home</BreadcrumbItem>
            <BreadcrumbItem active>{data.subtitle}</BreadcrumbItem>
          </Breadcrumb>
          <h1 className="hero-heading text-white">{data.title}</h1>
        </Container>
      </section>
      {/*
      <section className="py-6">
        <Container>
          <Row>
            {data.address && (
              <Col md="4" className="text-center text-md-start mb-4 mb-md-0">
                <div className="icon-rounded mb-4 bg-primary-light">
                  <Icon
                    icon="map-location-1"
                    className="w-2rem h-2rem text-primary"
                  />
                </div>
                <h3 className="h5">{data.address.title}</h3>
                <p className="text-muted">
                  {data.address.row1}
                  <br />
                  {data.address.row2}
                  <br />
                  <span
                    dangerouslySetInnerHTML={{ __html: data.address.row3 }}
                  />
                </p>
              </Col>
            )}
            {data.callcenter && (
              <Col md="4" className="text-center text-md-start mb-4 mb-md-0">
                <div className="icon-rounded mb-4 bg-primary-light">
                  <Icon icon="mail-1" className="w-2rem h-2rem text-primary" />
                </div>
                <h3 className="h5">{data.callcenter.title}</h3>
                <p className="text-muted">{data.callcenter.content}</p>
                <p className="text-muted">
                  <strong>{data.callcenter.phone}</strong>
                </p>
              </Col>
            )}
            {data.electronicsupport && (
              <Col md="4" className="text-center text-md-start mb-4 mb-md-0">
                <div className="icon-rounded mb-4 bg-primary-light">
                  <Icon
                    icon="map-location-1"
                    className="w-2rem h-2rem text-primary"
                  />
                </div>
                <h3 className="h5">{data.electronicsupport.title}</h3>
                <p className="text-muted">{data.electronicsupport.content}</p>
                <ul className="list-unstyled text-muted">
                  {data.electronicsupport.emails.map((email) => (
                    <li key={email}>{email}</li>
                  ))}
                </ul>
              </Col>
            )}
          </Row>
        </Container>
      </section> */}
      <section className="py-6 bg-gray-100">
        <Container>
          <h2 className="h4 mb-5">Get in touch</h2>
          <Row>
            <Col md="7" className="mb-5 mb-md-0">
              <ContactForm />
            </Col>
            <Col md="5">
              <div className="pl-lg-4">
                {data.content && (
                  <div dangerouslySetInnerHTML={{ __html: data.content }} />
                )}
                {/*  {data.social && (
                  <div className="social">
                    <ul className="list-inline">
                      {data.social.map((icon) => (
                        <li key={icon.icon} className="list-inline-item">
                          <a href={icon.link} target="_blank">
                            <i className={`fab fa-${icon.icon}`} />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )} */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <div className="map-wrapper-300">
        <Map
          className="h-100"
          center={[25.76401, -80.19178]}
          //markerPosition={[25.76401, -80.19178]}
          popupVenue
          zoom={16}
          geoJSON={geoJSON}
        />
      </div>
    </React.Fragment>
  )
}

export default Contact
